import React, { useEffect, useState, useLayoutEffect } from 'react';
import './LessonOverlay.css';

// Спотлайт-тур: затемнение + подсветка активного элемента + карточка с комментарием.
// steps: массив { target: 'data-lesson-target value', text: 'комментарий', autoOpen?: 'popover' | 'section:user_stats' | ... }

export default function LessonOverlay({ steps, onClose, onComplete, onAutoOpen }) {
  const [step, setStep] = useState(0);
  const [rect, setRect] = useState(null);
  const [forceShow, setForceShow] = useState(false);

  const current = steps[step];
  const isLast = step === steps.length - 1;

  useEffect(() => {
    if (current && current.autoOpen && onAutoOpen) onAutoOpen(current.autoOpen);
  }, [step]); // eslint-disable-line
  // Если пользователь кликает где-то вне карточки урока — прерываем урок.
  useEffect(() => {
    const handler = (e) => {
      if (e.target && e.target.closest && e.target.closest('.lesson-card')) return;
      if (onClose) onClose();
    };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, [onClose]);


  useLayoutEffect(() => {
    if (!current) return;
    let timer = null;
    let fallbackTimer = null;
    setRect(null);
    setForceShow(false);
    const measure = () => {
      const el = document.querySelector('[data-lesson-target="' + current.target + '"]');
      if (!el) return;
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      setRect({ top: r.top, left: r.left, width: r.width, height: r.height });
    };
    const scrollAndMeasure = () => {
      const el = document.querySelector('[data-lesson-target="' + current.target + '"]');
      if (el) { try { el.scrollIntoView({ block: 'center', behavior: 'auto' }); } catch (_) {} }
      setTimeout(measure, 80);
    };
    measure();
    timer = setTimeout(scrollAndMeasure, 350);
    // retry если первая попытка не нашла target
    const retry1 = setTimeout(measure, 600);
    const retry2 = setTimeout(measure, 900);
    fallbackTimer = setTimeout(() => setForceShow(true), 1200);
    const onResize = () => measure();
    // Только resize. Scroll-events не отслеживаем — иначе scrollIntoView ловит сам себя и карточка прыгает.
    window.addEventListener('resize', onResize);
    return () => {
      clearTimeout(timer);
      clearTimeout(retry1);
      clearTimeout(retry2);
      clearTimeout(fallbackTimer);
      window.removeEventListener('resize', onResize);
    };
  }, [step, current]);

  if (!current) return null;

  // Карточка прижата к низу или верху — чтобы не перекрывать спотлайт.
  const cardStyle = { position: 'fixed', left: '50%', transform: 'translateX(-50%)' };
  if (rect) {
    const vh = window.innerHeight;
    const targetCenter = rect.top + rect.height / 2;
    if (targetCenter < vh / 2) cardStyle.bottom = '24px';
    else cardStyle.top = '24px';
  } else {
    cardStyle.top = '50%';
    cardStyle.transform = 'translate(-50%, -50%)';
  }

  const spotlightStyle = rect ? {
    position: 'fixed',
    top: (rect.top - 6) + 'px',
    left: (rect.left - 6) + 'px',
    width: (rect.width + 12) + 'px',
    height: (rect.height + 12) + 'px',
  } : null;

  const handleNext = () => {
    if (isLast) { onComplete && onComplete(); }
    else { setStep((s) => s + 1); }
  };

  // Пока rect не вычислен — карточка скрыта, видно только затемнение.
  // forceShow срабатывает через 700ms если target так и не найден (например, кнопка скрыта по роли).
  const showCard = !!rect || forceShow;

  return (
    <>
      {!rect && <div className="lesson-overlay-fallback" />}
      {rect && <div className="lesson-spotlight" style={spotlightStyle} />}
      {showCard && <div className="lesson-card" style={cardStyle}>
        <p className="lesson-card-text">{current.text}</p>
        <div className="lesson-card-footer">
          <span className="lesson-card-step">{step + 1} / {steps.length}</span>
          <div className="lesson-card-buttons">
            <button type="button" className="lesson-btn-later" onClick={onClose}>Позже</button>
            <button type="button" className="lesson-btn-next" onClick={handleNext}>{isLast ? 'Готово' : 'Далее'}</button>
          </div>
        </div>
      </div>}
    </>
  );
}
